import * as types from './types';

export const load = () => ({
  type: types.LOAD,
  meta: {
    path: `/api/v1/status`
  }
});
